import { render, staticRenderFns } from "./SettingHistory.vue?vue&type=template&id=ef56707a&"
import script from "./SettingHistory.vue?vue&type=script&lang=js&"
export * from "./SettingHistory.vue?vue&type=script&lang=js&"
import style0 from "./SettingHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports